import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProofSection() {
  const stars = Array(5).fill(0);
  return <section className="py-20 px-4 relative" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 font-orbitron" data-id="element-213">
          Lo que dicen nuestros{' '}
          <span className="neon-text-green" data-id="element-214">Dinero Pros</span>
        </h2>

        <div className="flex flex-col lg:flex-row gap-8 items-center" data-id="element-215">
          <div className="flex-1 space-y-8 w-full" data-id="element-216">
            {/* Testimonial 1 */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="glass-panel border-l-4 border-l-[#39FF14] rounded-r-2xl p-6 md:p-8 relative" data-id="element-217">
              <div className="flex gap-1 mb-4 text-[#39FF14]" data-id="element-218">
                {stars.map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-219" />)}
              </div>
              <p className="text-lg text-gray-300 italic mb-6" data-id="element-220">
                "Pasé de gastarme mi mesada en dos días a ahorrar $500 para mi
                propia consola en solo 4 meses. Lo mejor es que mis padres ahora
                confían en mí para manejar montos más grandes porque ven que
                tengo un sistema."
              </p>
              <div className="flex justify-between items-end flex-wrap gap-4" data-id="element-221">
                <div data-id="element-222">
                  <p className="font-bold text-white" data-id="element-223">Javier M., 16 años</p>
                  <p className="text-sm text-gray-500" data-id="element-224">CDMX</p>
                </div>
                <div className="bg-[#39FF14]/10 text-[#39FF14] px-3 py-1 rounded-full text-sm font-medium border border-[#39FF14]/30" data-id="element-225">
                  Resultado: Compró su PS5 con ahorros propios
                </div>
              </div>
            </motion.div>

            {/* Testimonial 2 */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="glass-panel border-l-4 border-l-[#8B5CF6] rounded-r-2xl p-6 md:p-8 relative" data-id="element-226">
              <div className="flex gap-1 mb-4 text-[#39FF14]" data-id="element-227">
                {stars.map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-228" />)}
              </div>
              <p className="text-lg text-gray-300 italic mb-6" data-id="element-229">
                "Le compré este Blueprint a mi hija de 15 años pensando que no
                lo leería. Lo terminó en una tarde y al día siguiente me pidió
                que la ayudara a abrir una cuenta de inversión custodia. Por
                primera vez hablamos de dinero sin pelear."
              </p>
              <div className="flex justify-between items-end flex-wrap gap-4" data-id="element-230">
                <div data-id="element-231">
                  <p className="font-bold text-white" data-id="element-232">
                    Elena R., Madre de familia
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-233">Madrid</p>
                </div>
                <div className="bg-[#8B5CF6]/10 text-[#8B5CF6] px-3 py-1 rounded-full text-sm font-medium border border-[#8B5CF6]/30" data-id="element-234">
                  Resultado: Hija inició su primer portafolio ETF
                </div>
              </div>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex-1 hidden lg:block" data-id="element-235">
            <img src="https://cdn.magicpatterns.com/uploads/iWDQiKrXGkfCwkNce2JiPD/prueba_social.png" alt="Ahorros creciendo" className="w-full max-w-md mx-auto drop-shadow-[0_0_50px_rgba(139,92,246,0.3)]" data-id="element-236" />
          </motion.div>
        </div>
      </div>
    </section>;
}